"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  top: 1,
  bottom: 1,
  left: 1,
  right: 1
};


//////////////////
// WEBPACK FOOTER
// ./~/react-tab-panel/lib/tabPositions.js
// module id = 609
// module chunks = 0